import { render, staticRenderFns } from "./DistrictAdmin.vue?vue&type=template&id=5afc8e49"
import script from "./DistrictAdmin.vue?vue&type=script&lang=ts"
export * from "./DistrictAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports